<template>
  <generic-form
    v-slot="{ data }"
    :endpoints="endpoints"
    targetClass="md-size-100"
    creationEnabled
  >
    <md-table v-bind:value="data" v-fixedTableHeader>
      <md-table-row
        slot="md-table-row"
        slot-scope="{ item, index }"
        v-wavyDeletable="index"
      >
        <md-table-cell md-label="Name">
          <backend-text
            v-model="item.name"
            labelClass="no-asterisk"
            rules="required"
          ></backend-text
        ></md-table-cell>
        <md-table-cell md-label="Default">
          <md-field>
            <md-select v-model="item.default_wavy_segment_type">
              <md-option v-for="type in types" :key="type" :value="type">{{
                type
              }}</md-option>
            </md-select>
          </md-field>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </generic-form>
</template>

<script>
import Api from "../../../../openapi/src/api/WavySegmentApi.js";
import WavySegmentDTO from "../../../../openapi/src/model/WavySegmentDTO.js";
import SegmentsTypes from "../../../../openapi/src/model/WavySegmentType.js";

import BackendText from "../../Components/Inputs/BackendText.vue";
import GenericForm from "../GenericForm.vue";

export default {
  components: {
    GenericForm,
    BackendText
  },
  data() {
    const api = new Api();
    const vm = this;

    return {
      types: new SegmentsTypes(),
      endpoints: {
        get: api.getWavySegments.bind(api, vm.$root.hotelId),
        update: api.updateWavySegments.bind(api),
        delete: api.deleteWavySegment.bind(api)
      }
    };
  },
  methods: {
    constructNewItemFromObject(data) {
      return WavySegmentDTO.constructFromObject(
        Object.assign(WavySegmentDTO.prototype, data)
      );
    }
  }
};
</script>
